import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=60cd2689&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60cd2689')) {
      api.createRecord('60cd2689', component.options)
    } else {
      api.reload('60cd2689', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=60cd2689&", function () {
      api.rerender('60cd2689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/comp/ImgFallback2.vue"
export default component.exports